<template>
  <!--业主管理 ownerManager -->
  <div class="myownerManager">
     <div class="con">
       <div class="search-input-btn" style="width:100%">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small mr-20">
              <span>业主编号：</span>
               <el-input v-model="rfid" placeholder="请输入业主编号" style="width:140px;" show-word-limit></el-input>
            </div>
            <div class="input-small mr-20">
              <span>业主姓名：</span>
              <el-input v-model="name" placeholder="请输入业主姓名" style="width:140px;" show-word-limit></el-input>
            </div>
            <div class="input-small mr-20">
              <span>业主电话：</span>
             <el-input v-model="mobile" placeholder="请输入业主电话" style="width:140px;" show-word-limit></el-input>
            </div>
            <div class="input-small myinput-mill mr-20">
              <span>关联设备：</span>
             <el-select v-model="isBindDevice" placeholder="请选择" >
              <el-option v-for="item in relateStatusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            </div>
            <div class="input-small myinput-mill">
              <span>余额告警：</span>
             <el-select v-model="warning" placeholder="请选择" >
              <el-option v-for="item in balanceAlertChoice" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            </div>
            <el-button type="primary" plain @click="search" class="search-btn">查询</el-button>
            <el-button type="primary"  @click="addNewOwner" >新增</el-button>
            <el-button type="primary"  @click="exportReport" >导出</el-button>
          </div>
        </el-scrollbar>
      </div>
      <div class="mytable" :style="{'height':heights+'px'}">
        <!--custom-scrollbar-->
        <!--业主列表-->
        <el-table :data="dataList" border :height="heights - 20" style="width: 100%;height:100%;" v-loading="loading" stripe>
          <template slot="empty">
            <span class="noData">
              <img src="../../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="selection" width="44" align="center">
          </el-table-column>
          <el-table-column type="index" width="90" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="rfid" label="业主编号" width="140">
          </el-table-column>
          <el-table-column prop="username" label="姓名" width="140">
          </el-table-column>
          <el-table-column prop="mobile" width="120" label="手机号">
          </el-table-column>
          <el-table-column prop="address" label="地址">
          </el-table-column>
          <el-table-column prop="gender" label="性别" width="50">
          </el-table-column>
          <el-table-column prop="balanceAlarm" label="余额告警值(元)" width="150">
          </el-table-column>
          <el-table-column prop="isBindDevice" label="关联电表" width="90">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>电表名称: {{ scope.row.deviceNames }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">{{ scope.row.isBindDevice?"已关联":"未关联" }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="isBindWaterDevice" label="关联水表" width="90">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>水表名称: {{ scope.row.waterDeviceNames }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">{{ scope.row.isBindWaterDevice?"已关联":"未关联" }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column> -->

          <el-table-column prop="balance" label="账户余额(元)" width="120">
            <template slot-scope="scope">
              <p>{{ scope.row.balance ? (scope.row.balance/100).toFixed(2) : '0.00'}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="accountTime" label="开户时间" :formatter="formatTime" width="120">
          </el-table-column>
          <el-table-column label="操作" width="280" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="viewDetails(scope.row)" plain>详情</el-button>
              <el-button size="mini" type="primary" @click="editOwnerInfo(scope.row)" plain>编辑</el-button>
              <el-dropdown>
                <el-button type="primary">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><el-button size="mini" type="primary" @click="refundClick(scope.row)"
                      plain>退费</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button size="mini" type="danger"
                      @click="deleteOwnerInfo(scope.row)">删除</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button size="mini" type="danger"
                      @click="amountOfDeduction(scope.row)">补扣</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button size="mini" type="warning" @click="destruction(scope.row)"
                      plain>销户</el-button></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
       
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange"
          @handleSizeChange="handleSizeChange" />
      </div>
      </div>
    <!--退费弹窗-->
    <el-dialog title="退费" v-dialogDrag :visible.sync="refundShow" width="30%">
      <el-form :model="refundForm">
        <el-form-item label="退费设备" :label-width="formLabelWidth">
          <el-select v-model="device" collapse-tags placeholder="请选择" size='small'>
            <el-option v-for="(item,index) in userDeviceInfo" :key="index" :label="item.deviceName" :value="item">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="用户编号" :label-width="formLabelWidth">
          <el-input v-model="refundForm.userNumber" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="用户名" :label-width="formLabelWidth">
          <el-input v-model="refundForm.userName" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="地址" :label-width="formLabelWidth">
          <el-input v-model="refundForm.address" autocomplete="off" disabled></el-input>
        </el-form-item>

        <el-form-item v-if="device.meterRunType==1 && device.accountType==1" label="剩余电量" :label-width="formLabelWidth">
          <el-input disabled v-model="device.electricity" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item v-if="device.meterRunType==1 && device.accountType==1" label="电量转换金额"
          :label-width="formLabelWidth">
          <el-input disabled v-if="device.electricity ==0" autocomplete="off" placeholder="0"></el-input>
          <el-input disabled v-else v-model="device.electricity/device.conversionRate" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="退费原因" :label-width="formLabelWidth" required>
          <el-input v-model="refundForm.reason" type="text" placeholder="请输入退费原因"></el-input>
        </el-form-item> -->
        <el-form-item label="退费金额(元)" :label-width="formLabelWidth" required>
          <el-input v-if="device.meterRunType==1 && device.accountType==1" v-model="refundForm.refundAmount"
            type="number" class="numberInput" autocomplete="off"
            :placeholder="refundPlace=device.electricity/device.conversionRate"></el-input>
          <el-input v-else v-model="refundForm.refundAmount" type="number" class="numberInput" autocomplete="off"
            :placeholder="refundPlace"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth" required>
          <el-input v-model="confirmPassword" type="password" autocomplete="off" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="refundShow = false && setDeviceNull">取 消</el-button>
        <el-button type="primary" @click="confirmRefund">确 定</el-button>
      </div>
    </el-dialog>
    <!--补扣弹窗-->
    <el-dialog title="补扣" v-dialogDrag :visible.sync="amountOfDeductionShow">
      <el-form :model="deduction">
        <el-form-item label="补扣类型" :label-width="formLabelWidth">
          <el-select v-model="deduction.type" placeholder="补扣类型">
            <el-option label="补" value="补"></el-option>
            <el-option label="扣" value="扣"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额(元)" :label-width="formLabelWidth" required>
          <el-input v-model="deduction.balance" type="number" class="numberInput" autocomplete="off"
            placeholder="请输入补扣金额"></el-input>
        </el-form-item>
        <el-form-item label="补扣原因" :label-width="formLabelWidth">
          <el-input v-model="deduction.desc" type="text" class="numberInput" autocomplete="off"
            placeholder="请输入补扣原因"></el-input>
        </el-form-item>
        <p style="color: red">*补扣操作会直接更改业主的账户余额请谨慎使用</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="amountOfDeductionShow = false">取 消</el-button>
        <el-button type="primary" @click="amountOfDeductionConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <!--销户弹窗-->
    <el-dialog v-dialogDrag title="销户操作"  custom-class="destruction" :visible.sync="destruction_flag" width="830px"
      center>
      <div class="box">
        <div class="p">
          <div class="li">
            <div class="el-icon-tickets icon"></div>
            <div class="txt">地址:{{from.user&&from.user['地址']}}</div>
          </div>
          <div class="li">
            <div class="el-icon-user-solid icon" style="background: #87CF64;"></div>
            <div class="txt">用户名:{{from.user&&from.user['用户名']}}</div>
          </div>
          <div class="li">
            <div class="el-icon-money icon" style="background: #E6A23C;"></div>
            <div class="txt">余额:<span style="color: #E6A23C;">{{((from.user&&from.user['余额'])/100).toFixed(2)}}</span> 元</div>
          </div>
        </div>
        <div class="jiesuan">
          <div class="t">
            <div class="li"><i></i>手机号:<div class="tx">{{from.user&&from.user['手机号']}}</div>
            </div>
            <!-- <div class="li">状态: <div class="tx" style="color: #06c283; font-weight: bold;">合闸</div>
            </div> -->
            <div class="li">用户编号:<div class="tx">{{from.user&&from.user['用户编号']}}</div>
            </div>
          </div>

          <div class="b" v-for="(e, i) in from.table" :key="i">
            <div class="li">
              <div class="name">最后一次抄表时间</div>
              <div class="num">{{e['最后一次抄表时间']}}</div>
            </div>
            <div class="li">
              <div class="name">最后抄表值</div>
              <div class="num">{{e['最后抄表值']}}</div>
            </div>
            <div class="li">
              <div class="name">设备号</div>
              <div class="num">{{e['设备号']}}</div>
            </div>
            <div class="li"> <el-button type="primary" @click="juesuan(e['设备号'])">核算</el-button></div>
            <!-- :style="{opacity:i==0?1:0}" -->
          </div>
        </div>
        <div class="hexiao">
          <div class="t" style="color:#ff9b00"> 销户前请先进行手动结算操作，一旦销户，将不退费，请谨慎操作!</div>
          <div class="b">
            <div class="txt">结算后账户余额: <span style="color: red;">{{((from.user&&from.user['余额'])/100).toFixed(2)}}</span> 元</div>
            <div class="btn">
              <!-- <el-button @click="destruction_flag = false">核销</el-button> -->
              <el-button @click="refundClick(from.row)">退费</el-button>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="destruction_flag = false">取 消</el-button>
        <el-button type="primary" @click="xiaohu(from.row)">销 户</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import infoListMultipleSelection from './infoListMultipleSelection.vue'
  import singleSelection from '@/components/module/selection/singleSelection.vue'
  import ownerManagerStore from './ownerManagerStore.js'
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  import request from "@/api/http.js";
  export default {
    components: {
      infoListMultipleSelection,
      singleSelection,
      elPagination
    },
    props: {},
    data () {
      return {
       heights: document.getElementById('app').clientHeight-240,
        from: {//销户数据
          user: '',
          table: ''
        },
        destruction_flag: false,//销户弹窗
        pageIndex: 1,
        pageSize: 20,
        total: 0,
        userDeviceInfo: [],
        dataList: [],
        device: '',
        rfid: '',
        name: '',
        mobile: '',
        isBindDevice: undefined,
        isBindWaterDevice: undefined,
        warning: '',
        chargeMode: '',
        searchChange: false,
        //补扣对象
        deduction: {
          id: "",
          balance: 0,
          userName: "",
          type: "补",
          desc: "" //补扣原因
        },
        options: [{
          value: 'false',
          label: '否'
        },{
          value: 'true',
          label: '是'
        }],
        formLabelWidth: '120px',
        refundShow: false,
        amountOfDeductionShow: false,
        refundForm: {
          userNumber: '',
          userName: '',
          address: '',
          refundAmount: '',
          remarks: '',
          userId: '',
        },

        refundPlace: "",
        selectBalance: "", //当前的金额
        confirmPassword: '', //密码
        loading: false, //列表加载
      }
    },

    mounted () {
      this.search()
    },
    computed: {
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      chargeModeList () {
        return ownerManagerStore.state.chargeModeList
      },
      relateStatusList () {
        return ownerManagerStore.state.deviceStatusList
      },

      balanceAlertChoice () {
        return [{
          'label': '告警',
          'value': 0
        },{
          'label': '不告警',
          'value': 1
        }]
      },

      columns () {
        return ownerManagerStore.state.columns
      },
    },
    watch: {
      dataList (nv,ov) {
        ownerManagerStore.commit('getBindedDeviceNos')
      },
      nowUnit (nv,ov) {
        this.getOwnerList(nv)
      },
      rfid (nv,ov) {
        this.searchChange=true
      },
      name (nv,ov) {
        this.searchChange=true
      },
      mobile (nv,ov) {
        this.searchChange=true
      },
      isBindDevice (nv,ov) {
        this.searchChange=true
      },
      isBindWaterDevice (nv,ov) {
        this.searchChange=true
      },
      pageIndex () {
        this.search()
      }
    },
    methods: {
      // 销户
      xiaohu (row) {
        this.$confirm(`是否确定销户?`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var params={
            targetIds: row.id
          }
          request({url: "/accountCancellation/addUserAccountCancellation",method: "get",params}).then(res => {
            if(res.success) {
              this.$message({
                type: 'success',
                message: res.data
              });
              this.search();
              this.destruction_flag=false;
            } else {
              this.$message({
                type: 'info',
                message: '失败!'
              });
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 核算
      juesuan (row) {
        console.log(row);
        var params={
          targetId: this.from.id,
          deviceNos: row,
        }
        request({url: "/accountCancellation/stopDevice",method: "get",params}).then(res => {
          console.log(res,2);
          if(res.success) {
            var d=res.data.olas
            for(const key in d) {
              this.$notify({
                title: '提示',
                message: '表号：'+key+' 当前读数：'+d[key],
              });
            }

            this.$message({
              type: 'success',
              message: '核算成功!'
            });
          }

        })
      },
      // 销户
      destruction (row) {
        var params={
          targetId: row.id
        }
        console.log("销户",row);
        request({url: "/accountCancellation/getCurrentUserData",method: "get",params}).then(res => {
          this.from.user=res.data['用户'];
          this.from.table=res.data['表'];
          this.from.id=row.id;
          this.from.row=row;
          console.log(this.from,1);
        })
        this.destruction_flag=true;
      },
      refundClick (val) {

        this.getUserDeviceList(val);

        //退费
        this.refundForm.userNumber=val.rfid
        this.refundForm.userName=val.username
        this.refundForm.address=val.address
        this.selectBalance=val.balance
        this.refundPlace='最多可退'+(val.balance/100).toFixed(2)+'元'
        this.refundForm.userId=val.userId
        this.confirmPassword=''
        this.refundForm.refundAmount=''
        this.refundForm.remarks=''
        this.refundShow=true
      },

      setDeviceNull () {
        this.device={};
      },

      confirmRefund () {
        if(isempty(this.confirmPassword)) {
          this.$message.error('请输入密码')
          return
        }

        if(isempty(this.device)) {
          this.$message.error("请选择退款设备");
          return
        }

        if(this.refundForm.refundAmount==0) {
          this.$message.error("账户余额为0，无需退费");
          return
        }

        if(this.refundForm.refundAmount<0) {
          this.$message.error("'用户账户存在欠款，请充值");
          return
        }

        if(isempty(this.refundForm.refundAmount)) {
          this.$message.error('退费金额或者输入格式不对！')
          return
        }

        var refType=1; //1==退余额；2==退电量
        if(this.device.accountType==1&&this.device.meterRunType==1) {

          if(this.refundForm.refundAmount>(this.device.electricity/this.device.conversionRate)) {
            this.$message.error('退款金额大于账户余额')
            return
          }

          //退电量  金额线下退还
          //this.refundForm.refundAmount = this.refundForm.refundAmount * this.device.conversionRate;
          refType=2;

        } else {

          if(this.refundForm.refundAmount*100>this.selectBalance) {
            this.$message.error('退款金额大于账户余额')
            return
          }

          this.refundForm.refundAmount=this.refundForm.refundAmount*100;

        }
        //退费
        this.$api.meterReadingApi.refundAmount(this.device.conversionRate,this.device.deviceNo,refType,this.refundForm.userId,this.refundForm.refundAmount,hex_md5(this.confirmPassword),respon => {
          this.$message.success(respon)
          this.search()
          this.refundShow=false
        },err => {
          this.$message({
            type: 'error',
            message: err
          });
        })

        this.setDeviceNull();
      },
      //当前页
      pageindexChange (val) {
        this.pageIndex=val;
        this.search()
      },
      //页大小
      handleSizeChange (val) {
        this.pageSize=val;
        this.pageIndex=1;
        this.search()
      },
      // 选择计费方式
      selectChargeMode (item) {
        this.chargeMode=item.value
      },
      addNewOwner () {
        this.$emit('add')
      },
      viewDetails (item) {
        this.$emit('view',item)
      },
      editOwnerInfo (item) {
        this.$emit('edit',item)
        console.log("编辑",item);
        ownerManagerStore.commit('setOwnerEditing',item)
      },
      deleteOwnerInfo (item) {
        this.getUserDeviceList(item);
        this.$confirm("确认删除业主编号："+item.rfid+' 姓名：'+item.username+'的业主信息？','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log("删除");
          if(!this.deleteCheck(item)) {
            return
          }

          this.$api.userApi.deleteUserById(item.id,res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.search()
            ownerManagerStore.commit('getAllOwnerRfidList')
            ownerManagerStore.commit('getBindedDeviceNos')
            ownerManagerStore.commit('getDeviceNos',this.nowUnit.id)

          },message => {
            console.log(message);
            this.$message(message)
          })
        }).catch(() => {
          console.log("取消删除");
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      //业主设备列表
      getUserDeviceList (val) {
        this.$api.meterReadingApi.getUserDeviceList(val.userId,respon => {
          this.userDeviceInfo=respon;
        })
      },

      amountOfDeduction (val) {
        //退费
        this.deduction.userName=val.username
        this.deduction.id=val.userId
        this.amountOfDeductionShow=true
      },
      amountOfDeductionConfirm () {
        //补扣
        if(!this.deductionCheck()) {
          return;
        }
        this.$confirm("确认业主："+this.deduction.userName+','+this.deduction.type+this.deduction.balance+"元?",'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //补扣
          this.$api.userApi.amountOfDeduction(this.deduction.id,this.deduction.balance,this.deduction.desc,this.deduction.type,respon => {
            this.$message({
              type: 'success',
              message: '补扣成功!'
            });
            this.search()
            ownerManagerStore.commit('getAllOwnerRfidList')
            ownerManagerStore.commit('getBindedDeviceNos')
            ownerManagerStore.commit('getDeviceNos',this.nowUnit.id)
            this.deduction.balance=""
            this.deduction.desc=""
            this.amountOfDeductionShow=false
          },message => {
            this.$message(message)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消补扣'
          });
        });
      },

      deductionCheck () {
        if(this.deduction.balance<=0) {
          this.$message.error('请输入正确的补扣金额')
          return false;
        }

        if(this.deduction.desc=="") {
          this.$message.error('请输入补扣原因')
          return false;
        }

        return true;

      },

      // 批量删除
      deleteBatches () {
        var keys=Object.keys(this.$refs.infoList.nowSelectIds)
        var ownerIds=[]
        keys.forEach(key => {
          if(this.$refs.infoList.nowSelectIds[key]) {
            ownerIds.push(key)
          }
        })
        if(ownerIds.length<=0) {
          this.$dialogMethod.showMessage('请选择要批量删除的业主！')
          return
        }
        this.$api.userApi.deleteUserById(ownerIds.join(','),respon => {
          this.$dialogMethod.showMessage('批量删除业主成功！')
          this.search()
          ownerManagerStore.commit('getAllOwnerRfidList')
          ownerManagerStore.commit('getBindedDeviceNos')
        },message => {
          this.$dialogMethod.showMessage(message)
        })
      },
      exportReport () {
        this.$store.cacheStore.state.load=true
        this.$api.meterReadingApi.exportOwnerList(this.rfid,this.name,this.mobile,this.isBindDevice==''? false:this.isBindDevice,this.warning,respon => {
          this.$store.cacheStore.state.load=false
          saveAs(DWSystemSetting.downloadUrl+'/'+respon,'业主信息表'+".xls")
        })
      },
      search () {
        this.getOwnerList(this.nowUnit)
      },
      getOwnerList (unit) {
        if(!unit||!unit.id) {
          return
        }
        this.loading=true
        this.$api.meterReadingApi.getOwnerList(unit.id,this.pageIndex,this.pageSize,this.rfid,this.name,this.mobile,this.isBindDevice,this.warning,respon => {
          this.total=respon.total
          // console.log(respon);
          this.dataList=respon.dataList
          this.loading=false
        })
      },
      // 切换每页显示条数
      pageSizeChange (pageSize) {
        this.pageIndex=1
        this.pageSize=pageSize
        this.search()
      },
      // 切换当前显示页码
      jumpToPage (pageIndex) {
        this.pageIndex=pageIndex
        this.search()
      },
      formatTime (row,column,cellValue) {
        return new Date(row.accountTime).format('yyyy-MM-dd')
      },

      //删除业主、批量删除业主  判断
      deleteCheck (item) {
        if(item.balance!=0&&!isempty(item.balance)) {
          this.$message.error('用户账户未结算，请先结算')
          return false;
        }

        let deviceList=this.userDeviceInfo;

        this.userDeviceInfo.forEach(function(value,index,deviceList) {
          if(value.electricity!=0&&!isempty(value.electricity)) {
            this.$message.error('电表剩余电量未清零')
            return false;
          }
        })
        return true;
      }

    }
  }
</script>

<style scoped lang="scss">
   .myownerManager {
    width: 100%;
    height: 100%;
      .con {
         width: 100%;
         height: 100%;
         padding: 2px 20px 12px 20px;
         background-color: #fff;
         box-sizing: border-box;
         overflow: hidden;
      }
       .myinput-mill {
      /deep/.el-input__inner {
        width: 90px;
      }
      /deep/.el-input {
          width: 90px !important;
      }
      
   }
   .my-search-i {
         /deep/.el-button {
          padding: 10px 14px !important;
         }
      }
   }
  .box .hexiao .txt {
    font-weight: bold;
  }
 .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }
  .box .hexiao .t {
    line-height: 25px;
    margin-top: 15px;
  }

  .box .hexiao .b {
    display: flex;
    height: 50px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #d7d7d7;
  }

  .box .jiesuan .b .li {
    margin-top: 15px;
    line-height: 25px;

  }

  .box .jiesuan .b {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d7d7d7;
  }

  .box .jiesuan {
    border-bottom: 1px solid #d7d7d7;
    padding: 20px;
    position: relative;
  }

  .box .jiesuan .t {
    display: flex;
    justify-content: space-between;
  }

  .box .jiesuan .t i {
    position: absolute;
    width: 10px;
    height: 10px;
    background: #1f87ff;
    left: 4px;
    top: 25px;
  }

  .box .jiesuan .t .tx {
    display: inline-block;
    min-width: 95px;
  }

  .box .p {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d7d7d7;
    padding-bottom: 25px;
    font-weight: bold;
  }

  .box .p .li {
    display: flex;
    align-items: center;
  }

  .box .p .li .icon {
    background: #409EFF;
    border-radius: 50%;
    font-size: 15px;
    color: #fff;
    padding: 4px;
    margin-right: 9px;
  }


  .page_top_form::-webkit-scrollbar {
    width: 5px;
  }


  .ownerList {
    padding: 0 20px 0 20px;
    height: calc(100% - 73px);
  }

  .ownerList::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .ownerList::-webkit-scrollbar-track {
    box-shadow: none;
    background-color: #FFFFFF;
  }

  .ownerList:hover::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F0F0F0;
  }

  .ownerList::-webkit-scrollbar-thumb {
    background-color: #FFFFFF;
  }

  .ownerList:hover::-webkit-scrollbar-thumb {
    background-color: #CACACA;
  }

  .ownerList>div {
    width: calc(100% - 10px);
  }

  .normalStatus {
    display: inline-block;
    border: solid 1px #87CF64;
    border-radius: 4px;
    color: #87CF64;
    background-color: #F0F9EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .wrongStatus {
    display: inline-block;
    border: solid 1px #F9A6A6;
    border-radius: 4px;
    color: #F9A6A6;
    background-color: #FEF1F1;
    line-height: 28px;
    padding: 0 6px;
  }

  .waitStatus {
    display: inline-block;
    border: solid 1px #E6A23C;
    border-radius: 4px;
    color: #E6A23C;
    background-color: #FDF6EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .normalStatus:hover,
  .wrongStatus:hover,
  .waitStatus:hover {
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
  }

  .operateBtn {
    display: inline-block;
    border-radius: 4px;
    line-height: 28px;
    padding: 0 6px;
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
    margin-right: 8px;
    cursor: pointer;
  }

  .operateBtn:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 1500px) {
    .ownerList {
      height: calc(100% - 96px);
    }
  }
</style>